module.exports = __webpack_public_path__ + "img/checkmark.4f6e53c3.png";